"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ethTransferTransaction = void 0;
var types_1 = require("../types");
exports.ethTransferTransaction = function (recipient, amount) { return ({
    to: recipient,
    typeCode: types_1.CallType.Call,
    data: "0x",
    value: amount.toString(),
}); };
